__turbopack_context__.v({
  "card": "BlogTeaser-module__JZROia__card",
  "fallback": "BlogTeaser-module__JZROia__fallback",
  "fallbackInner": "BlogTeaser-module__JZROia__fallbackInner",
  "image": "BlogTeaser-module__JZROia__image",
  "imageLink": "BlogTeaser-module__JZROia__imageLink",
  "link": "BlogTeaser-module__JZROia__link",
  "playBadge": "BlogTeaser-module__JZROia__playBadge",
});
